import Ajax from '../js/common/ajax';

export const Ai = {
  getPdfInfo(form) {
    return Ajax.post("/ai/import/pdf-info", form, {'Content-Type': 'multipart/form-data'})
  },
  importBank(form) {
    return Ajax.post("/ai/import/bank", form, {'Content-Type': 'multipart/form-data'})
  },
  importInvoice(form) {
    return Ajax.post("/ai/import/invoice", form, {'Content-Type': 'multipart/form-data'})
  },
  importExcel(form, direction) {
    return Ajax.post("/ai/import/excel?direction=" + direction, form, {'Content-Type': 'multipart/form-data'})
  },
  records(page) {
    return Ajax.get("/ai/records", page)
  },
  confirm(ids) {
    return Ajax.post("/ai/confirm", ids)
  },
  generate(ids) {
    return Ajax.post("/ai/generate", ids)
  },
  deleteRecords(ids) {
    return Ajax.delete("/ai/records", {data: ids})
  },
  // 凭证管理删除：只删凭证，保留导入记录并恢复为待生成
  deleteVouchersOnly(ids) {
    return Ajax.delete("/ai/records/vouchers", {data: ids})
  },
  updateRecord(id, data) {
    return Ajax.put("/ai/records/" + id, data)
  },
  // AI匹配规则管理
  getRules() {
    return Ajax.get("/ai/rules")
  },
  saveRule(data) {
    return Ajax.post("/ai/rules", data)
  },
  deleteRules(ids) {
    return Ajax.delete("/ai/rules", {data: ids})
  },
  initRulesFromTemplate() {
    return Ajax.post("/ai/rules/init")
  },
  // 第1层规则：明细内容 -> 业务大类
  getL1Rules() {
    return Ajax.get("/ai/rules/l1")
  },
  saveL1Rule(data) {
    return Ajax.post("/ai/rules/l1", data)
  },
  deleteL1Rule(id) {
    return Ajax.delete("/ai/rules/l1/" + id)
  },
  deleteL1Rules(ids) {
    return Ajax.delete("/ai/rules/l1", {data: ids})
  },
  billingStats(params) {
    return Ajax.get("/ai/billing/stats", params)
  },
  billingRecords(params) {
    return Ajax.get("/ai/billing/records", params)
  },
  billingAccountSets() {
    return Ajax.get("/ai/billing/account-sets")
  },
  billingStatsAll(params) {
    return Ajax.get("/ai/billing/stats/all", params)
  },
  billingRecordsAll(params) {
    return Ajax.get("/ai/billing/records/all", params)
  },
  billingTokenBalance() {
    return Ajax.get("/ai/billing/token-balance")
  }
}
